export default {
  getAutocompletePhases: (state) => state.autocompletePhases,
}